
import each from 'lodash/each';
import { connect } from 'react-redux';
import { setFilter } from '../store';

export const CheckboxItem = ({name, value, checked, disabled, onChange}) => {
    return (
        <label className={"checkbox " + (checked ? "checked" : "")} data-disabled={disabled}>
            <input type="checkbox" value={value} disabled={disabled} checked={checked} onChange={e => onChange(value)} />
            <span>{name}</span>
        </label>
    );
};

export function toggleFilterOption(options, value) {
    let new_options = options.map(opt => { return { ...opt } }); /* Copy all options */
    console.log(new_options);

    let has_exclusive = false;
    each(options, (opt, i) => {
        if ( opt.exclusive ) {
            if ( has_exclusive ) {
                throw new Error("[CheckboxList] There is more than one exclusive option specified. This does not make sense, don't you think?");
            }
            has_exclusive = true;
        }
    })

    /* Toggle current option */
    let target = null;
    each(new_options, (opt, i) => {
        if ( opt.value === value ) {
            opt.checked = !opt.checked;
            target = opt;
        }
    });

    if ( !target ) {
        return console.error("User clicked on a unknown option with value: %o", value);
    }

    if ( target.exclusive ) {

        // Find all other options and disable them
        each(new_options, (opt, i) => {
            if ( !opt.exclusive ) {
                opt.checked = false;
            }
        });

    } else {

        // Find the exclusive one and uncheck it
        each(new_options, (opt, i) => {
            if ( opt.exclusive ) {
                opt.checked = false;
            }
        });

    }

    if ( has_exclusive ) {
        let any_non_exclusive_checked = false;
        each(new_options, (opt, i) => {
            if ( !opt.exclusive && opt.checked ) {
                any_non_exclusive_checked = true;
            }
        });

        if ( !any_non_exclusive_checked ) {
            // Find the exclusive one and check it
            each(new_options, (opt, i) => {
                if ( opt.exclusive ) {
                    opt.checked = true;
                }
            });
        }

    }

    return new_options
}

let CheckboxList = ({name, options, horizontal, onChange}) => {

    let _onChange = value => {
        let new_options = toggleFilterOption(options, value);
        onChange(name, new_options);
    }

    return (    
        <div className={"checkbox-group " + (horizontal ? "horizontal" : "vertical")}>
            { options.map(o => <CheckboxItem {...o} onChange={_onChange} key={o.value} />) }
        </div>
    );
};

CheckboxList.propTypes = {
    name: React.PropTypes.string,
    options: React.PropTypes.array,
    horizontal: React.PropTypes.bool,
}

CheckboxList.defaultProps = {
    name: "",
    options: [],
    horizontal: false,
}


export function createBoundedCheckboxList(key) {

    let mapStateToProps = (state) => {
        return {
            name: key,
            options: state.filter[key] || [],
        };
    };

    let mapDispatchToProps = (dispatch, ownProps) => {
        return {
            onChange: (name, new_options) => {
                dispatch(setFilter(name, new_options));
            },
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(CheckboxList);
}


export default connect()(CheckboxList);



// WEBPACK FOOTER //
// ./components/CheckboxList.js